﻿import timetable_register from './timetableRegister.js';

var timetable = {};

timetable = {

  init: function () {

    timetable_register.initialize();

  }
};

timetable.initialize = function () {
  timetable.init();
};

module.exports = timetable;
